import $ from 'jquery';

window.addEventListener('load', function(event) {

  $.each($("textarea.textarea"), function() {
    const $this = $(this)

    $this.removeAttr('rows');

    const resizeTextarea = function(e) {
    //e.style.overflow = "hidden"
      
      setTimeout(function() {
        let offset = e.offsetHeight - e.clientHeight;
        e.style.height = "auto"
        e.style.height = (offset + e.scrollHeight) + "px"
        //e.style.overflow = "auto"
      }, 0)
    };

    $this.on("keydown input", function() {
      resizeTextarea(this)
    });

    resizeTextarea(this)
  });
   
});